import {CountUp} from '../vendors/countup.min';
import scrollMonitor  from '../vendors/scrollMonitor.min';

export default function counter () {
    const numbers = document.querySelectorAll('[data-number]');

    if (numbers.length) {
        numbers.forEach(el => {
            const dataNumber = el.getAttribute('data-number');
            const val = dataNumber.replaceAll(' ', '');
            const fixedValue = val.replaceAll(',', '.');
            const fixedValueNumber = Number(fixedValue);
            const config = Number.isInteger(fixedValueNumber)
                ? { startVal: 0, decimalPlaces: 0, duration: 3 }
                : { startVal: 0, decimalPlaces: fixedValue.split('.')[1].length, duration: 3 };

            const number = new CountUp(el, fixedValueNumber, config);

            const watcher = scrollMonitor.create(el, { top: -50, bottom: 0 });
            const startAnimation = () => {
                if (watcher.isInViewport) {
                    number.start();
                }
            };

            startAnimation();
            watcher.stateChange(startAnimation);
        });
    }
}
